import React from 'react'
import '../../../styles/Instructions.css'
function Cards() {
  return (
    
<div className='container'>
<div className="panel-horizontal-content mb-5" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal d-flex justify-content-center align-items-center w-100">
  <h1 className="">IMPLEMENTACIÓN IDECABA.</h1>
  </div>
</div>

<div className="card-items-3 custom-margin" >
  <div className="col">
    <div className="card">
      <i className="bg-dark bx bx-play text-white card-icon"></i>
      <div className="card-body">
        <h3 className="card-title">
          <a href="#" className="card-title-link ">Tutorial de cómo navegar y qué información se encontrará en el Portal</a>
        </h3>
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card">
      <i className="bg-dark bx bx-play text-white card-icon"></i>
      <div className="card-body">
        <h3 className="card-title">
          <a href="#" className="card-title-link ">Tutorial de cómo navegar el Visor</a>
        </h3>
        
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card">
      <i className="bg-dark bx bx-play text-white card-icon"></i>
      <div className="card-body">
        <h3 className="card-title">
          <a href="#" className="card-title-link ">Tutorial de consumo de información: Servicios WMS y WFS</a>
        </h3>
        
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card ">
      <i className="bg-dark bx bx-play text-white card-icon"></i>
      <div className="card-body">
        <h3 className="card-title">
          <a href="#" className="card-title-link ">Tutorial de aplicaciones (APIs: normalización, geocoder, conversión de coordenadas,
            datos útiles, etc...)</a>
        </h3>
        
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card ">
      <i className="bg-dark bx bx-play text-white card-icon"></i>
      <div className="card-body">
        <h3 className="card-title">
          <a href="#" className="card-title-link ">Tutorial de uso del catálogo y descarga de información</a>
        </h3>
        
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card ">
      <i className="bg-dark bx bx-play text-white card-icon"></i>
      <div className="card-body">
        <h3 className="card-title">
          <a href="#" className="card-title-link ">Tutorial de consulta y descarga de Metadatos</a>
        </h3>
        
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card">
      <i className="bg-dark bx bx-play text-white card-icon"></i>
      <div className="card-body">
        <h3 className="card-title">
          <a href="#" className="card-title-link ">Instructivo para instalar qGis</a>
        </h3>
        
      </div>
    </div>
  </div>
  <div className="col">
    <div className="card">
      <i className="bg-dark bx bx-play text-white card-icon"></i>
      <div className="card-body">
        <h3 className="card-title">
          <a href="#" className="card-title-link ">Instructivo para la visualización de WMS/WFS utilizando qGis</a>
        </h3>
        
      </div>
    </div>
  </div>
</div>
</div>

  )
}

export default Cards